import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/AuthPages.css';

function RoleSelectionPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="hb-auth-page">
      <div className="hb-split-card">
        {/* Left Side: Soothing Wellness Visual */}
        <div className="hb-visual-panel">
          <img
            src="/assets/images/auth-soothing-wellness.jpg"
            alt="Find your calm - PsychMitra Wellness"
            className="hb-visual-bg-img"
          />
          <div className="hb-visual-overlay"></div>

          <div className="hb-visual-content-top">
            <div className="hb-calm-badge">
              <span className="hb-pulse-dot"></span>
              PSYCHMITRA ECOSYSTEM
            </div>
          </div>

          <div className="hb-visual-content-bottom">
            <div className="hb-quote-box">
              <p className="hb-quote-text">
                "A gentle, compassionate ecosystem connecting individuals with verified mental health experts."
              </p>
              <p className="hb-quote-author">— Ethical &amp; Evidence-Based Care</p>
            </div>

            <div className="hb-pill-chips-row">
              <span className="hb-pill-chip">
                <i className="fas fa-lock"></i> 100% Confidential
              </span>
              <span className="hb-pill-chip">
                <i className="fas fa-certificate"></i> Verified Specialists
              </span>
              <span className="hb-pill-chip">
                <i className="fas fa-shield-heart"></i> Safe Space
              </span>
            </div>
          </div>
        </div>

        {/* Right Side: Account Type Selection */}
        <div className="hb-form-panel">
          <div className="hb-form-header">
            <h1 className="hb-form-title">Join PsychMitra</h1>
            <p className="hb-form-subtitle">
              Choose how you'd like to experience personalized mental health support.
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '28px' }}>
            {/* Option 1: Client */}
            <div
              onClick={() => navigate('/register/client')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter') navigate('/register/client'); }}
              style={{
                background: '#faf8f5',
                border: '1.5px solid #e7e2dc',
                borderRadius: '18px',
                padding: '24px 22px',
                cursor: 'pointer',
                transition: 'all 0.25s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '18px',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#7c4bb9';
                e.currentTarget.style.background = '#ffffff';
                e.currentTarget.style.boxShadow = '0 10px 24px rgba(124, 75, 185, 0.1)';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#e7e2dc';
                e.currentTarget.style.background = '#faf8f5';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div
                style={{
                  width: '52px',
                  height: '52px',
                  borderRadius: '16px',
                  background: '#ede9fe',
                  color: '#7c3aed',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '22px',
                  flexShrink: 0
                }}
              >
                <i className="fas fa-heart"></i>
              </div>
              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 700, margin: '0 0 4px 0', color: '#1e1b2e' }}>
                  I'm Seeking Care &amp; Support
                </h3>
                <p style={{ fontSize: '0.85rem', color: '#6b6378', margin: 0, lineHeight: 1.45 }}>
                  For individuals &amp; families looking for confidential therapy, counselling, and child support.
                </p>
              </div>
              <i className="fas fa-chevron-right" style={{ color: '#9ca3af', fontSize: '14px' }}></i>
            </div>

            {/* Option 2: Professional */}
            <div
              onClick={() => navigate('/pricing')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter') navigate('/pricing'); }}
              style={{
                background: '#faf8f5',
                border: '1.5px solid #e7e2dc',
                borderRadius: '18px',
                padding: '24px 22px',
                cursor: 'pointer',
                transition: 'all 0.25s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '18px',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#059669';
                e.currentTarget.style.background = '#ffffff';
                e.currentTarget.style.boxShadow = '0 10px 24px rgba(5, 150, 105, 0.1)';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#e7e2dc';
                e.currentTarget.style.background = '#faf8f5';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div
                style={{
                  width: '52px',
                  height: '52px',
                  borderRadius: '16px',
                  background: '#d1fae5',
                  color: '#059669',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '22px',
                  flexShrink: 0
                }}
              >
                <i className="fas fa-user-doctor"></i>
              </div>
              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 700, margin: '0 0 4px 0', color: '#1e1b2e' }}>
                  I'm a Mental Health Professional
                </h3>
                <p style={{ fontSize: '0.85rem', color: '#6b6378', margin: 0, lineHeight: 1.45 }}>
                  For Clinical Psychologists, Psychiatrists, Counsellors, and Therapists expanding their practice.
                </p>
              </div>
              <i className="fas fa-chevron-right" style={{ color: '#9ca3af', fontSize: '14px' }}></i>
            </div>
          </div>

          {/* Footer */}
          <div className="hb-form-footer">
            <p style={{ margin: 0 }}>
              Already have an account? <Link to="/login">Sign In</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RoleSelectionPage;
